import { observer } from "mobx-react-lite";

import { ExportPatientRecordModal } from "@modules/practice/screens/shared-components/export-patient-record-modal/ExportPatientRecordModal.tsx";
import { useStores } from "@stores/hooks/useStores.ts";

import { ExportPatientRecordContext } from "./context/ExportPatientRecordContext.ts";
import { ExportPatientRecordHelper } from "./context/ExportPatientRecordHelper.ts";
import { ExportPatientRecordPasswordDialog } from "./ExportPatientRecordPasswordDialog.tsx";

export const ExportPatientRecord = observer(() => {
  const stores = useStores();
  const { practice } = stores;
  const {
    showExportPatientRecordModal,
    showExportPatientRecordPasswordDialog
  } = practice.ui;
  if (!showExportPatientRecordModal && !showExportPatientRecordPasswordDialog) {
    return null;
  }

  const helper = new ExportPatientRecordHelper(stores);

  return (
    <ExportPatientRecordContext.Provider value={helper}>
      {showExportPatientRecordModal && <ExportPatientRecordModal />}
      {showExportPatientRecordPasswordDialog && (
        <ExportPatientRecordPasswordDialog />
      )}
    </ExportPatientRecordContext.Provider>
  );
});
